import React, { memo, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFormikContext, Field } from 'formik';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

const DateField = memo(({ name, label, ...rest }) => {
  const { t, i18n } = useTranslation();
  const { setFieldValue, initialValues, errors } = useFormikContext();
  const initialValue = initialValues[name];
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setSelectedDate(initialValue ? new Date(initialValue) : null);
  }, [initialValue]);

  const onChange = useCallback(
    (date) => {
      setSelectedDate(date);
      if (!date || date.toString() === 'Invalid Date') {
        setFieldValue(name, '');
      } else {
        setFieldValue(name, moment(date).format('YYYY-MM-DD'));
      }
    },
    [name, setFieldValue],
  );

  return (
    <>
      <MuiPickersUtilsProvider utils={MomentUtils} locale={i18n.language}>
        <KeyboardDatePicker
          label={t(label)}
          value={selectedDate}
          onChange={onChange}
          error={!!errors[name]}
          helperText={t(errors[name])}
          {...rest}
        />
      </MuiPickersUtilsProvider>
      <Field name={name} type="hidden" />
    </>
  );
});

DateField.propTypes = {
  ...KeyboardDatePicker.propTypes,
  name: PropTypes.string.isRequired,
};

DateField.defaultProps = {
  ...KeyboardDatePicker.defaultProps,
  variant: 'inline',
  inputVariant: 'outlined',
  format: 'DD/MM/YYYY',
  margin: 'dense',
  autoOk: true,
  fullWidth: true,
};

export default DateField;
